import React from 'react';
import { connect } from 'react-redux';
import { REF_PATH as productPath } from './Const';
import { getProductListWrapper } from './ProductWrapper.js';
import { formatProductLabel } from '@/component/blogic/deals/elements/BaseElement.jsx';
import PackingDisplayWrapper from '../../simple/packing/NameDisplayWrapper';

class ProductInPackingDisplayWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = { name: this.createName(props) };
    this.color = this.props.color || 'inherited';
  }
  componentWillMount() {
    if (!this.props.products || this.props.products.size == 0) {
      getProductListWrapper();
    }
    if (this.props.products && this.props.products.size > 0) {
      this.setState({ name: this.createName(this.props) });
    }
  }
  componentWillReceiveProps(props) {
    if (!props.products || props.products.size == 0) {
      getProductListWrapper();
    }
    if (props.products && props.products != this.props.products
        || props.products && props.packingId != this.props.packingId
        || props.products && props.productTypeId != this.props.productTypeId) {
      this.setState({ name: this.createName(props) });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.name === this.state.name
        && nextProps.packingId === this.props.packingId) {
      return false;
    }
    return true;
  }
  createName(props) {
    let name = undefined;
    if (props.products) {
      props.products.forEach(prod => {
        const found = prod.get('productTypes')
          .find(ptype => ptype.get('id') == props.productTypeId);
        if (found != undefined) {
          name = `${prod.get('name')}${found.get('name') == 'DEFAULTPRODUCTTTYPE'
            ? '' : ` / ${found.get('name')}`}`;
        }
      });
    }
    return name;
  }
  render() {
    const defaultStyle = {
      display: 'inline-block',
      wordBreak: 'break-all',
      whiteSpace: 'normal' };
    return (<span style={{ display: 'inline' }}>
      <div
        style={this.props.noBorder ? defaultStyle : { ...defaultStyle,
          border: 'thin solid rgba(150, 150, 150, 0.4)',
          borderRadius: '5px',
          padding: '3px',
          marginBottom: '3px',
          background: `${this.color}`,
        }}
      >
        {formatProductLabel(this.state.name,
          this.props.packingId
            ?
            <PackingDisplayWrapper
              id={this.props.packingId}
            />
            : '')
        }
      </div>
    </span>);
  }
}
ProductInPackingDisplayWrapper.propTypes = {
  packingId: React.PropTypes.oneOfType(
    [React.PropTypes.number,
      React.PropTypes.string,
    ]),
  productTypeId: React.PropTypes.oneOfType(
    [React.PropTypes.number,
      React.PropTypes.string,
    ]),
  products: React.PropTypes.object,
  color: React.PropTypes.string,
  noBorder: React.PropTypes.bool,
};
export default connect((state) => ({
  products: state.getIn(['references', 'complex', productPath]),
})
)(ProductInPackingDisplayWrapper);
